import {Component, computed, inject, input, Optional, SkipSelf} from '@angular/core';
import {
  ControlContainer,
  FormGroup,
  FormGroupDirective,
  FormGroupName,
  ReactiveFormsModule,
} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SelectButtonModule} from 'primeng/selectbutton';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {DirectusTranslatedItem} from '@frontend/directus';
import {DirectusTooltipComponent} from '../../../directus-tooltip/directus-tooltip.component';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {startWith, switchMap, of} from 'rxjs';
import {InputTextModule} from 'primeng/inputtext';

@Component({
  selector: 'app-form-field-select-button',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectButtonModule,
    InputTextModule,
    TranslocoPipe,
    TranslateDirectusPipe,
    DirectusTooltipComponent,
  ],
  templateUrl: './form-field-select-button.component.html',
  styleUrls: ['./form-field-select-button.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (parentGroupName: FormGroupName, parentFormDir: FormGroupDirective) =>
        parentGroupName ?? parentFormDir,
      deps: [
        [new Optional(), new SkipSelf(), FormGroupName],
        [new Optional(), new SkipSelf(), FormGroupDirective],
      ],
    },
  ],
})
export class FormFieldSelectButtonComponent {
  @Optional() private readonly controlContainer = inject(ControlContainer);

  id = input.required<string>();
  fieldName = input.required<string>();
  options = input.required<DirectusTranslatedItem[]>();
  label = input<string>('');
  isReadOnly = input<boolean>(false);
  smallLabel = input<boolean>(false);
  isMandatory = input<boolean>(false);

  readonly form = computed(() => this.controlContainer?.control as FormGroup);

  readonly formControlValue = toSignal(
    toObservable(this.fieldName).pipe(
      switchMap((name) => {
        const ctrl = this.form()?.get(name);
        return ctrl ? ctrl.valueChanges.pipe(startWith(ctrl.value)) : of(null);
      }),
    ),
  );

  readonly selectedOptionTranslations = computed(() => {
    const value = this.formControlValue();
    const selected = this.options().find((opt) => opt.id === value);
    return selected ? selected.translations : null;
  });
}
